<template>
    <div class="score-list">
        <span class="pic icon-trophey"></span>
        <p class="name"> Pretraži rezultate </p>

        <div>
            <Loading :loadingState="monthsLoadingState">
                <transition name="fade" appear>
                    <select v-bind:class="{ 'prevent-handler': requestInProcess }" class="select month-select" name="monthSelected" v-model="monthSelected">
                        <option :value="val" v-for="(val, index) of months" v-bind:key="index">{{ getMonth(val) }}</option>
                        <option v-if="!this.isGroupsSelected" :value="totalMonth">Ukupno</option>
                    </select>
                    <template v-slot:error>
                        <ErrorMessageText></ErrorMessageText>
                    </template>
                </transition>
            </Loading>

            <Loading :loadingState="quizzesLoadingState">
                <transition name="fade" appear>
                    <template v-if="quizes && quizes.length > 0">
                        <select v-bind:class="{ 'prevent-handler': requestInProcess }" class="select" name="" v-model="quizSelected">
                            <option :value="val.quizKey" v-for="(val) in quizes" v-bind:key="val.key">{{ val.title }}</option>
                        </select>
                    </template>
                    <template v-if="quizes && quizes.length == 0 && !totalPointsSelected">
                        <p class="no-results"></p>
                        <NoResults message="Nažalost nema rezultata za odabrani mjesec, molimo odaberite drugi mjesec, ako je moguće."></NoResults>
                    </template>
                    <template v-slot:error>
                        <ErrorMessageText></ErrorMessageText>
                    </template>
                    <template v-slot:on-hold>Molimo odaberite mjesec</template>
                </transition>
            </Loading>

            <Loading :loadingState="resultsLoadingState">
                <transition name="fade" appear>
                    <template v-if="results && results.length > 0">
                        <ul>
                            <ListRezultataSingle
                                v-for="(val, index) in results"
                                v-bind:key="index"
                                :value="val"
                                :quizSelected="quizSelected"
                                :ligaSelected="ligaSelected"
                                :userPosition="index + 1"
                                :isUserLiga="isUserLiga"></ListRezultataSingle>
                            <infinite-loading @infinite="infiniteHandler">
                                <div slot="no-more"></div>
                                <div slot="no-results"></div>
                            </infinite-loading>
                        </ul>
                    </template>
                    <template v-if="results && results.length == 0">
                        <NoResults message="Nažalost nema rezultata za odabrano Kolo, molimo odaberite drugo kolo, ako je moguće"></NoResults>
                    </template>
                    <template v-slot:error>
                        <ErrorMessageText></ErrorMessageText>
                    </template>
                </transition>
            </Loading>
        </div>
    </div>
</template>

<script>
import ListRezultataSingle from './lista-rezultata/ListRezultataSingle'
import Loading from './common/Loading.vue'
import LoadingState from './../utils/loading/LoadingState'
import { TimeUtils } from '../utils/timeUtils'
import ErrorMessageText from './common/error/ErrorMessageText'
import NoResults from './common/error/NoResults'
import { ApplicationState } from '../application-state'
import InfiniteLoading from 'vue-infinite-loading'

export default {
    name: 'lista-rezultata',
    components: {
        ListRezultataSingle,
        Loading,
        ErrorMessageText,
        NoResults,
        InfiniteLoading
    },
    props: ['ligaSelected'],
    data: function () {
        return {
            monthsLoadingState: LoadingState.LOADING,
            quizzesLoadingState: LoadingState.ON_HOLD,
            resultsLoadingState: LoadingState.ON_HOLD,

            quizSelected: null,
            monthSelected: null,
            quizes: {},
            months: [],
            results: [],
            totalMonth: 99,
            totalPointsSelected: false,
            page: 1,
            resultsShown: 0,
            infiniteLoadingState: undefined,
            requestInProcess: false
        }
    },
    mounted: function () {
        if (this.appState !== ApplicationState.LOADING_DATA) {
            this.initialLoadata()
        }
    },
    watch: {
        monthSelected: function (after, before) {
            this.totalPointsSelected = this.monthSelected === 99
            this.getQuizzesByLeaugeAndMonth()
        },
        quizSelected: function (after, before) {
            this.resetPagination()
            this.getResultsForQuiz()
        },
        ligaSelected () {
            this.quizzesLoadingState = LoadingState.ON_HOLD
            this.resultsLoadingState = LoadingState.ON_HOLD
            if (this.ligaSelected) {
                this.getAllMonthsForYear()
            }
        },
        appState (after, before) {
            if (before === ApplicationState.LOADING_DATA) {
                this.initialLoadata()
            }
        }
    },
    computed: {
        appState () {
            return this.$store.state.appState
        },
        userLiga () {
            try {
                return this.$store.state.metadata.userData.liga
            } catch (error) {
                return 4
            }
        },
        isUserLiga () {
            try {
                return typeof this.ligaSelected === 'string' && this.ligaSelected.length > 1
            } catch (error) {
                return false
            }
        },
        isGroupsSelected () {
            try {
                return this.ligaSelected === 'groups'
            } catch (error) {
                return false
            }
        }
    },
    methods: {
        initialLoadata () {
            return true
        },
        getMonth (jsMonth) {
            return TimeUtils.getMonthName(jsMonth)
        },
        resetPagination () {
            this.page = 1
            this.resultsShown = 0
            if (this.infiniteLoadingState !== undefined) {
                this.infiniteLoadingState.reset()
            }
        },
        async doRequest (request) {
            if (!this.requestInProcess) {
                this.requestInProcess = true
                let response = await request
                this.requestInProcess = false
                return response
            }
            return {}
        },
        async getAllMonthsForYear () {
            this.monthsLoadingState = LoadingState.LOADING
            try {
                this.months = []
                // TODO: remove 2019 when new league starts
                // harcoded for now to be able to see results from 2019.
                this.months = await this.doRequest(this.$db.results.getAllMonthsForYear())
                if (this.months.length > 0) {
                    this.monthSelected = this.months[this.months.length - 1]
                }
                this.monthsLoadingState = LoadingState.SUCCESS
                try {
                    this.getQuizzesByLeaugeAndMonth()
                } catch (error) { }
            } catch (error) {
                this.monthsLoadingState = LoadingState.ERROR
            }
        },
        async getQuizzesByLeaugeAndMonth () {
            try {
                this.quizzesLoadingState = LoadingState.LOADING
                let ligaId = Number.parseInt(this.ligaSelected)
                if (isNaN(ligaId)) {
                    ligaId = this.ligaSelected === 'groups' ? Number.parseInt(this.userLiga) : this.ligaSelected
                }
                this.quizes = []
                if (!this.totalPointsSelected) {
                    this.quizes = await this.doRequest(this.$db.results.getQuizzesByLeauge(ligaId, false, this.monthSelected))
                }
                let quizKeys = Object.keys(this.quizes || {})
                if (quizKeys.length > 0) {
                    if (this.quizSelected === this.quizes[quizKeys[quizKeys.length - 1]].quizKey) {
                        this.quizSelected = this.quizes[quizKeys[quizKeys.length - 1]].quizKey
                        this.resultsLoadingState = LoadingState.LOADING
                        this.resetPagination()
                        await this.getResultsForQuiz()
                    } else {
                        this.quizSelected = this.quizes[quizKeys[quizKeys.length - 1]].quizKey
                    }
                } else if (this.totalPointsSelected) {
                    this.resetPagination()
                    await this.getTotalPointsResult()
                }
                this.quizzesLoadingState = LoadingState.SUCCESS
            } catch (error) {
                console.error(error)
                this.quizzesLoadingState = LoadingState.ERROR
            }
        },
        async getTotalPointsResult () {
            try {
                this.results = await this.doRequest(this.$db.results.getTotalPointsByLeague(this.ligaSelected, (this.page * 10)))
                this.resultsLoadingState = LoadingState.SUCCESS
            } catch (error) {
                console.error(error)
                this.resultsLoadingState = LoadingState.ERROR
                this.results = []
            }
        },
        async getResultsForQuiz () {
            try {
                if (!this.isGroupsSelected) {
                    this.results = await this.doRequest(this.$db.results.getResultsForQuiz(this.ligaSelected, this.quizSelected, (this.page * 10)))
                } else {
                    let liga = Number.parseInt(this.userLiga)
                    this.results = await this.doRequest(this.$db.results.getResultsForGroups(liga, this.quizSelected, (this.page * 10)))
                }
                this.resultsLoadingState = LoadingState.SUCCESS
            } catch (error) {
                console.error(error)
                this.resultsLoadingState = LoadingState.ERROR
                this.results = []
            }
        },
        async infiniteHandler ($state) {
            if (this.infiniteLoadingState === undefined) {
                this.infiniteLoadingState = $state
            }
            this.page++
            if (this.resultsShown !== this.results.length) {
                this.resultsShown = this.results.length
                if (this.totalPointsSelected) {
                    await this.getTotalPointsResult()
                } else {
                    await this.getResultsForQuiz()
                }
                $state.loaded()
            } else {
                $state.complete()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.score-list {
    position: relative;
    box-shadow: 0px 9px 16px 0px rgba(0, 0, 0, 0.16);
    background-color: #fff;
    border-radius: 5px;
    padding: 54px 12px 9px;
    margin-top: 30px;

    .no-results {
        padding: 15px 0;
    }

    .pic {
        display: block;
        position: absolute;
        left: calc(50% - 40px);
        top: -30px;
        width: 80px;
        height: 80px;
        border-radius: 50%;
        border: 5px solid #fff;
        background-color: #fff;
        background-position: 50%;
        background-size: cover;
    }

    .name {
        font-family: "axiforma";
        font-size: 16px;
        letter-spacing: .3px;
        color: #000;
        margin-bottom: 10px;
    }

    .select {
        display: block;
        border-radius: 0;
        width: 100%;
        appearance: none;
        outline: none;
        text-align: left;
        font-family: "axiforma";
        font-size: 16px;
        line-height: 22px;
        letter-spacing: .3px;
        color: #000;
        border: none;
        border-bottom: 1px solid #d7d7d7;
        margin-bottom: 20px;
        padding-left: 4px;
        background: url(~@/assets/img/icons/icon-carrot.png) 98% 50% no-repeat;
        background-size: 6px;
        &.month-select {
            text-transform: capitalize;
            option {
                text-transform: capitalize;
            }
        }
    }

    .prevent-handler {
        pointer-events: none;
        opacity: 0.5;
    }

    ul {
        position: relative;
        margin-top: 44px;
    }
    /deep/ .loading-error {
        color: red;
        font-weight: bold;
    }
}
</style>
